import React, { useEffect } from "react";
import { filterOption } from "../../../../helpers/FormHelper";

import {Button, Col, Form, InputNumber, Row, Select, Input} from "antd";
import { AudioMutedOutlined, StopOutlined } from "@ant-design/icons";

interface propsInterface {
  params?: { duration: string; period?: number; type?: 'mute' | 'ban' } | undefined;
  onFinish: Function;
}

const _Form = ({ params, onFinish }: propsInterface) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
  }, [params, form]);

  const BlockBtn = () => {
    if (params?.type === 'ban') {
      return (
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          <StopOutlined /> Ban
        </Button>
      )
    }

    if (params?.type === 'mute') {
      return (
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          <AudioMutedOutlined /> Mute
        </Button>
      )
    }

    return null;
  }

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      className='v-form v-form-ban'
      initialValues={params}
    >
      <Form.Item name='type' noStyle>
        <Input type="hidden" />
      </Form.Item>

      <Row gutter={16}>
        <Col className="gutter-row" span={10}>
          <Form.Item name='period'>
            <InputNumber min={0} placeholder='5' />
          </Form.Item>
        </Col>

        <Col className="gutter-row" span={8}>
          <Form.Item name="duration">
            <Select
              showSearch
              filterOption={filterOption}
              placeholder="Select period"
            >
              <Select.Option value="minutes">minutes</Select.Option>
              <Select.Option value="hours">hours</Select.Option>
              <Select.Option value="days">days</Select.Option>
            </Select>
          </Form.Item>
        </Col>

        <Col className="gutter-row" flex="auto">
          <Form.Item>
             <BlockBtn />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
}

export default _Form;
